import { getQiniuToken } from '../api/login';
import { imgDomain } from '../configs/env'

export default {
  data() {
    return {
      imgDomain,
      uploadData: {
        token: '',
        // saveKey: '',
        // key: '',
      },
    };
  },
  created() {
    this.getQiniuToken();
  },
  methods: {
    beforeAvatarUploadImages(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "jpg" ||
        testmsg === "JPG" ||
        testmsg === "png" ||
        testmsg === "PNG" ||
        testmsg === "bpm" ||
        testmsg === "jpeg" ||
        testmsg === "JPEG" ||
        testmsg === "gif" ||
        testmsg === "GIF" ||
        testmsg === "BPM";

      if (!extension) {
        this.$message.warning('上传图片只能是jpg /gif / jpeg / gif / png / bpm格式!');
        return false;
      }
      console.log(file);
      // this.uploadData.saveKey = file.name
      // this.uploadData.key = file.name
      console.log(this.uploadData)
    },
    async getQiniuToken() {
      const { status, data } = await getQiniuToken()
      if (status !== 200) return
      this.uploadData.token = data.token
    },
  },
};



// WEBPACK FOOTER //
// ./src/jslib/qiniu.js